import React from 'react';

import UserContainer from '../containers/user-container';

const Name = ({ name = '', email = '' }) => (name || email);

const UserName = ({ id }) => <UserContainer id={id}><Name /></UserContainer>;

export default UserName;
